import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';

export function reformatYYYYMMDDtoDDMMYYYY(date: string): string {
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy');
}

export function reformatDDMMYYYYtoYYYYMMDD(date: string): string {
    return format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd');
}
